export default __webpack_public_path__ + "static/media/lab-v4.c15e5cc8.png";